export const SET_PREFERRED_REGION = 'SET_PREFERRED_REGION';
export const SET_DEFAULT_REGION = 'SET_DEFAULT_REGION';
export const FETCH_DEFAULT_REGION = 'FETCH_DEFAULT_REGION';
export const FETCH_PREFERRED_REGION = 'FETCH_PREFERRED_REGION';
export const SET_LAST_CHOSEN_REGION = 'SET_LAST_CHOSEN_REGION';
export const SHOW_REGION_SWITCH_MODAL = 'SHOW_REGION_SWITCH_MODAL';
export const HIDE_REGION_SWITCH_MODAL = 'HIDE_REGION_SWITCH_MODAL';